/** Dağıtım etiketi tahmin edilmez; Vite production modu ortam adı değildir. */
const configured = String(import.meta.env.VITE_APP_ENV ?? '').toLowerCase();
export const environment = {
  label:
    configured === 'production'
      ? 'PRODUCTION'
      : configured === 'staging'
        ? 'STAGING'
        : import.meta.env.DEV
          ? 'YEREL'
          : 'ORTAM BELİRTİLMEDİ',
  production: configured === 'production',
  // API göreli /admin/v1 adresini kullanır; proxy arkasındaki upstream bilinmez.
  host: typeof window === 'undefined' ? '' : window.location.host,
};
